import { createStyles, Group } from '@mantine/core';
import { Text } from '@repo/foundations';
import { useCallback, useRef } from 'react';
import { ROW_HEIGHT } from '../../components/TableV2/TableV2.styles';

const useStyles = createStyles(() => ({
	title: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		flex: 1,
	},
}));

interface TrashTitleRenderProps {
	record: {
		id: string;
		title?: string;
		title_cased?: string;
		icon?: string;
		onExpandClick?: (id: string) => void;
		paramExpandedLevel?: number;
		paramExpandedParentPrefix?: string;
		paramExpanded?: boolean;
	};
}

export function TrashTitleRender({ record }: TrashTitleRenderProps) {
	const { classes, theme } = useStyles();

	const textRef = useRef<HTMLDivElement>(null);

	const isEllipsisHidden = useCallback(
		(e: HTMLDivElement | null) => (e ? e.offsetWidth >= e.scrollWidth : false),
		[]
	);

	return (
		<Group
			data-testid="title-render"
			spacing={0}
			sx={{
				flexWrap: 'nowrap',
				height: ROW_HEIGHT,
			}}
		>
			<Text ref={textRef} className={classes.title} size="sm">
				{record.title_cased || record.title}
			</Text>
		</Group>
	);
}
